export interface ConsumerReviewandRatingsAction {
  type: string;
}

const consumerReviewandRatings = (state = {}, action: ConsumerReviewandRatingsAction,) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default consumerReviewandRatings;
